/**
 * Utilitário para verificar horário de atendimento
 * Horário de atendimento: 8h às 2h da manhã (18 horas)
 * Fora do horário: 2h às 8h (bot)
 */

export interface BusinessHoursStatus {
  isBusinessHours: boolean;
  isBotHours: boolean;
  currentTime: Date;
  nextBusinessHour: Date;
  message: string;
}

/**
 * Verifica se está em horário de atendimento
 * @returns true se está entre 8h e 2h da manhã
 */
export const isBusinessHours = (): boolean => {
  const now = new Date();
  const hour = now.getHours();
  
  // Horário de atendimento: 8h às 2h da manhã (8h até 1h59)
  // Isso significa: hour >= 8 OU hour < 2
  return hour >= 8 || hour < 2;
};

/**
 * Retorna informações detalhadas sobre o horário de atendimento
 */
export const getBusinessHoursStatus = (): BusinessHoursStatus => {
  const now = new Date();
  const hour = now.getHours();
  const isBusiness = isBusinessHours();
  
  let nextBusinessHour: Date;
  let message: string;
  
  if (isBusiness) {
    // Se está em horário de atendimento, calcular quando termina
    if (hour >= 8) {
      // Está entre 8h e 23h59, o próximo horário de bot é às 2h do dia seguinte
      nextBusinessHour = new Date(now);
      nextBusinessHour.setDate(nextBusinessHour.getDate() + 1);
      nextBusinessHour.setHours(2, 0, 0, 0);
      message = `Atendimento humano disponível até ${nextBusinessHour.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
    } else {
      // Está entre 0h e 1h59, o próximo horário de bot é às 2h do mesmo dia
      nextBusinessHour = new Date(now);
      nextBusinessHour.setHours(2, 0, 0, 0);
      message = `Atendimento humano disponível até ${nextBusinessHour.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
    }
  } else {
    // Está em horário de bot (2h às 7h59)
    // O próximo horário de atendimento é às 8h do mesmo dia
    nextBusinessHour = new Date(now);
    nextBusinessHour.setHours(8, 0, 0, 0);
    message = `Atendimento por bot. Atendimento humano retorna às ${nextBusinessHour.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
  }
  
  return {
    isBusinessHours: isBusiness,
    isBotHours: !isBusiness,
    currentTime: now,
    nextBusinessHour,
    message
  };
};

/**
 * Formata o horário de atendimento para exibição
 */
export const getBusinessHoursDisplay = (): string => {
  return "8h às 2h (atendimento humano) | 2h às 8h (atendimento por bot)";
};



